import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../const/Messages";
import * as SectionService from "../../../../../../service/DocumentSectionService";

export default function SectionList() {
  const history = useHistory();
  const [data, setData] = useState([]);

  useEffect(() => {
    SectionService.findAll()
      .then((data) => {
        setData(data);
      })
      .catch(() => {
        toast.error(ErrorUnexpected);
      });
  }, []); // eslint-disable-line

  function handleDelete(id) {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        SectionService.deleteById(id)
          .then(() => {
            SectionService.findAll()
              .then((data) => {
                setData(data);
                toast.success(OperationSuccessfully);
              })
              .catch(() => {
                toast.error(ErrorUnexpected);
              });
          })
          .catch((error) => {
            const errorMsg = error?.response?.data?.title || ErrorUnexpected;
            toast.error(errorMsg ? errorMsg : ErrorUnexpected);
          });
      }
    });
  }

  const columns = [
    {
      title: "Title",
      field: "title",
      defaultSort: "asc",
    },
  ];

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title d-flex justify-content-between align-items-center">
            <h5>Section - List</h5>
            <div>
              <Link
                className="btn btn-primary"
                to={{
                  pathname: "/settings/document/Section/reg",
                  state: { id: "" },
                }}
              >
                New Section
              </Link>
            </div>
          </div>
          <div className="ibox-content">
            <MaterialTable
              title=""
              columns={columns}
              data={data}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              options={{
                sorting: true,
                pageSize: 10,
                pageSizeOptions: [5, 10, 15, 20],
                actionsColumnIndex: -1,
                exportButton: true,
                exportAllData: true,
                searchFieldAlignment: "left",
                toolbarButtonAlignment: "right",
                exportFileName: "Section",
                headerStyle: {
                  textTransform: "uppercase",
                },
              }}
              actions={[
                {
                  icon: () => <FiEdit size={16} color="#007bff" />,
                  tooltip: "EDIT",
                  onClick: (event, rowData) =>
                    history.push("/settings/document/Section/reg", {
                      id: rowData.id,
                    }),
                },
                {
                  icon: () => <FiTrash2 size={16} color="#007bff" />,
                  tooltip: "DELETE",
                  onClick: (event, rowData) => handleDelete(rowData.id),
                },
              ]}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
